import React, { Component } from 'react'
import { connect } from 'react-redux'

import StepButton from '../step-button/StepButton'
import BackButton from '../back-button/BackButton'
import TextSwiper from '../text-swiper/TextSwiper'
import ProgressBar from '../progressbar/ProgressBar'

import { getTexts } from '../../actions/ContentActions'

class TextScreen extends Component {
  static defaultProps = {
    texts: []
  }

  constructor(props) {
    super(props)
    this.state = {
      postcard: JSON.parse(localStorage.getItem('postcard'))
    }
  }

  getTextIndex = (value, arr, prop) => {
    for(var i = 0; i < arr.length; i++) {
        if(arr[i][prop] === value) {
            return i;
        }
    }
    return -1
  }

  handleTextChange = () => {
    var maxIndex = this.props.texts.length-1
    var currentIndex = this.getTextIndex(this.state.postcard.text, this.props.texts, 'id')
    var nextIndex = currentIndex+1

    if(currentIndex >= maxIndex) {
      nextIndex = 0
    }

    var textId = this.props.texts[nextIndex].id;

    this.setState({
      postcard: {
        ...this.state.postcard,
        text: textId
      }
    })

    let localPostcard = JSON.parse(localStorage.getItem('postcard'))
    localPostcard.text = textId

    localStorage.setItem('postcard', JSON.stringify(localPostcard));    
  }

  componentWillMount() {
    const { postcard } = this.state
    this.props.dispatch(getTexts(postcard.type))
  }

  render() {

    const { texts, referer } = this.props
    const { postcard } = this.state

    var index = this.getTextIndex(postcard.text, texts, 'id')

    return (
      <div>
        <ProgressBar step="2" reverse={(referer.action !== "PUSH") ? 'reverse' : 'normal'}/>
        <h1 style={{marginTop: '20px'}} className="blue">Мы уже нашли нужные слова!</h1>
        <p>Духи кузбасской тайги зарядили эти строки на удачу, богатство и процветание. Пожелай что-нибудь скорее!</p> 

        <TextSwiper onTextChange={this.handleTextChange} index={index} texts={texts} />

        <div className="buttons-row">
          <BackButton title="Назад"/>
          <StepButton small={true} title="Продолжить" icon={true} navigateTo="background"/>
        </div>  
      </div>
    );
  }
}

export default connect((state) => ({
  texts: state.texts.data,
  referer: state.routing.locationBeforeTransitions
}))(TextScreen)


// WEBPACK FOOTER //
// ./src/components/postcard/TextScreen.js